let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eA9cu")).then(() => parcelRequire('iFaar'));